__turbopack_context__.v({
  "root": "Container-module__6x8z3q__root",
  "rootLg": "Container-module__6x8z3q__rootLg",
});
